var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 461,
    height: 300,
    viewBox: "0 0 461 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.43 173.312V206.418H10.7676L8.7168 180.783L97.6328 39.7188H131.178L94.8496 100.51L50.6113 173.312H164.43ZM140.26 39.7188V253H98.0723V39.7188H140.26Z",
    fill: "url(#paint0_linear_5442_56065)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M305.57 127.609V164.523C305.57 180.539 303.861 194.357 300.443 205.979C297.025 217.502 292.094 226.975 285.648 234.396C279.301 241.721 271.732 247.141 262.943 250.656C254.154 254.172 244.389 255.93 233.646 255.93C225.053 255.93 217.045 254.855 209.623 252.707C202.201 250.461 195.512 246.994 189.555 242.307C183.695 237.619 178.617 231.711 174.32 224.582C170.121 217.355 166.898 208.762 164.652 198.801C162.406 188.84 161.283 177.414 161.283 164.523V127.609C161.283 111.594 162.992 97.873 166.41 86.4473C169.926 74.9238 174.857 65.5 181.205 58.1758C187.65 50.8516 195.268 45.4805 204.057 42.0625C212.846 38.5469 222.611 36.7891 233.354 36.7891C241.947 36.7891 249.906 37.9121 257.23 40.1582C264.652 42.3066 271.342 45.6758 277.299 50.2656C283.256 54.8555 288.334 60.7637 292.533 67.9902C296.732 75.1191 299.955 83.6641 302.201 93.625C304.447 103.488 305.57 114.816 305.57 127.609ZM263.236 170.09V121.896C263.236 114.182 262.797 107.443 261.918 101.682C261.137 95.9199 259.916 91.0371 258.256 87.0332C256.596 82.9316 254.545 79.6113 252.104 77.0723C249.662 74.5332 246.879 72.6777 243.754 71.5059C240.629 70.334 237.162 69.748 233.354 69.748C228.568 69.748 224.32 70.6758 220.609 72.5312C216.996 74.3867 213.92 77.3652 211.381 81.4668C208.842 85.4707 206.889 90.8418 205.521 97.5801C204.252 104.221 203.617 112.326 203.617 121.896V170.09C203.617 177.805 204.008 184.592 204.789 190.451C205.668 196.311 206.938 201.34 208.598 205.539C210.355 209.641 212.406 213.01 214.75 215.646C217.191 218.186 219.975 220.041 223.1 221.213C226.322 222.385 229.838 222.971 233.646 222.971C238.334 222.971 242.484 222.043 246.098 220.188C249.809 218.234 252.934 215.207 255.473 211.105C258.109 206.906 260.062 201.438 261.332 194.699C262.602 187.961 263.236 179.758 263.236 170.09Z",
    fill: "url(#paint1_linear_5442_56065)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M452.43 173.312V206.418H298.768L296.717 180.783L385.633 39.7188H419.178L382.85 100.51L338.611 173.312H452.43ZM428.26 39.7188V253H386.072V39.7188H428.26Z",
    fill: "url(#paint2_linear_5442_56065)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5442_56065",
    x1: 58.6696,
    y1: 79.5,
    x2: 66.1018,
    y2: 255.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5442_56065",
    x1: 161.291,
    y1: 174,
    x2: 219.198,
    y2: 276.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5442_56065",
    x1: 314.326,
    y1: 181.5,
    x2: 386.744,
    y2: 282.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error-404.e182502637d2e48218e47be700f39a03.svg";
export { ForwardRef as ReactComponent };